export default __webpack_public_path__ + "static/media/team-feature.b72a44ee.jpg";